const recordKeepingQuestionnaire = {
    "title": "建立紀錄",
    "sections": [
        {
            "subject": "紀錄",
            "description": ["所有的活動、處理、作業紀錄須保持5年，並符合標準","有機產品應能追蹤至生產/收成的田區或地點","所有的紀錄應隨時提供稽核員查核"],
            "questions": [
                {
                    "description": "有機生產中您保有下列何種紀錄?",
                    "type": "mcq",
                    "options": ["農場工作日誌", "土壤改良、種子、種苗、繁殖體、廄肥、葉面噴施及害物防治資材等投入資材的購買及使用紀錄(保留所有標籤)", "尋求有機種子及繁殖體的文件", "有機種苗的文件",
                                "投入資材的殘留分析(例如:外購廄肥)", "堆肥製作紀錄 (例如:堆肥方式、成分、碳氮比、溫度、翻堆次數)", "監測紀錄(土壤、植株、水及品質檢驗、觀察結果)", "設備清潔紀錄",
                                "作物採收紀錄，包含田區代號、採收日期及數量(含委外採收紀錄)", "標章使用紀錄", "倉儲紀錄，包含儲存地點、儲存標識、田區代號、數量和清潔紀錄", "運輸工具清潔紀錄",
                                "銷售紀錄(含訂貨單、合約、發票、收據、現金帳、銷售紀錄等)", "出貨紀錄(過磅單、轉運站單據、提單)", "交易證明", "客訴紀錄", {"value":"其它", "elaboration": "請說明"}]
                },
                {
                    "description": "您紀錄保存多久?",
                    "type": "oeq"
                },
                {
                    "description": "在慣行生產中您是否保有紀錄?",
                    "type": "scq",
                    "options": ["是", "不適用"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "在慣行生產中您保有下列何種紀錄?",
                            "type": "mcq",
                            "options": ["農場圖", "工作紀錄", "農地歷史表", "倉儲紀錄", "資材投入紀錄", "銷售紀錄", "採收紀錄", "出貨紀錄", {"value": "其它", "elaboration": "請說明"}]
                        }
                    ]
                }
            ]
        },
        {
            "subject": "標示方法",
            "questions": [
                {
                    "description": "標示是否有可追溯的批號或日期?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "請附上所有有機產品的標籤(僅適用於NOP)",
                    "type": "oeq",
                    "format": {
                        "multiple": false,
                        "fields": [":file"]
                    }
                },
                {
                    "description": "標示是否符合規範?(僅適用於NOP)",
                    "type": "scq",
                    "options": ["是", "否"]
                },
            ]
        }
    ]
}

export default recordKeepingQuestionnaire;